"use strict"
exports.__esModule = true;
exports.PenAltIconConfig = {
  name: 'PenAltIcon',
  height: 512,
  width: 512,
  svgPath: 'M497.94 74.17l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.75 18.75-49.15 0-67.91zm-246.8-20.53c-15.62-15.62-40.94-15.62-56.56 0L75.8 172.43c-6.25 6.25-6.25 16.38 0 22.62l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l101.82-101.82 22.63 22.62L93.95 290.03A327.038 327.038 0 0 0 .17 485.11l-.03.23c-1.7 15.28 11.21 28.2 26.49 26.51a327.02 327.02 0 0 0 195.34-93.8l196.79-196.79-82.77-82.77-84.85-84.85z',
  yOffset: 0,
  xOffset: 0,
};
exports.PenAltIcon = require('../createIcon').createIcon(exports.PenAltIconConfig);
exports["default"] = exports.PenAltIcon;